<agr-page-toolbar
  [pageTitle]="'feed-advice.overview.title' | translate"
  [hasPrimaryAction]="isAdvisor"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="onButtonCreate()"
  [emptyTitle]="'feed-advice.overview.empty.title' | translate"
  [emptyDescription]="'feed-advice.overview.empty.description' | translate"
  emptyImage="assets/images/flock-cycle.jpg"
  [isEmpty]="(feedAdvices$ | async)?.length === 0"
  data-test="feed-advice__overview"
>
  <div class="wrapper--spacing-horizontal wrapper--spacing-vertical">
    <agr-table [config]="tableConfig"> </agr-table>
    <ng-template #columnActiveTemplate let-row="row">
      <mat-slide-toggle
        [hideIcon]="true"
        data-test="feed-advice__overview-toggle-active"
        color="primary"
        [disabled]="!isAdvisor"
        [checked]="row.isActive"
        (change)="onToggleActive(row)"
      >
      </mat-slide-toggle>
    </ng-template>
    <ng-template #columnNameTemplate let-row="row">
      <button
        mat-button
        class="button--text"
        (click)="onViewFeedAdvice(row)"
        data-test="feed-advice__view-button"
      >
        {{ row.name }}
      </button>
    </ng-template>
  </div>
</agr-page-toolbar>
